import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import {
	jsonMapProperty,
	jsonProperty,
	jsonClass,
} from '@sumbricht/json-class-serializer'
import { BoReference } from './bo-reference.js'
import { ServerDataStoreEntryDbField } from './server-data-store-entry-db-field.js'

@jsonClass('ServerDataStoreEntry')
export class ServerDataStoreEntry extends BoReference {
	@jsonProperty()
	isAutogenerateId: boolean = true
	@jsonMapProperty(String, ServerDataStoreEntryDbField)
	fields = new Map<string, ServerDataStoreEntryDbField>()

	constructor(init?: Partial<ServerDataStoreEntry>) {
		super()
		assignCommonProperties(this, init)
	}

	getField(name: string) {
		let field = this.fields.get(name)
		if (!field) {
			console.log('Field not found:', name)
			field = new ServerDataStoreEntryDbField()
			this.fields.set(name, field)
		}
		return field
	}
}
